import { call, put, takeLatest, select } from 'redux-saga/effects';

import { types } from '../constants';
import * as branchesApi from '../api/branches';
import { submitMode } from '../constants';

function* getLoggedInUserId() {
  const extractLoggedInUserId = (state) => state.users.user.item;

  const loggedInUser = yield select(extractLoggedInUserId);
  const loggedInUserId = loggedInUser && loggedInUser.id;
  return loggedInUserId;
}

function* watchLoadBranchesList() {
  try {
    const loggedInUserId = yield getLoggedInUserId();
    yield put({ type: types.START_GET_ALL_BRANCH });

    const { jsonData } = yield call(branchesApi.getAllBranches, loggedInUserId);

    yield put({ type: types.GET_ALL_BRANCH_SUCCESS, branches: jsonData }); //Temp fettching dummy data
  } catch (e) {
    yield resolveError(types.GET_ALL_BRANCH_FAILURE, e);
  } finally {
    yield put({ type: types.GET_ALL_BRANCH_FINISH });
  }
}

function* watchCreateEditBranch({ branch, mode }) {
  try {
    const loggedInUserId = yield getLoggedInUserId();
    yield put({ type: types.START_SUBMIT_BRANCH });
    const { jsonData } =
      mode === submitMode.CREATE
        ? yield call(branchesApi.createBranch, branch, loggedInUserId)
        : yield call(branchesApi.updateBranch, branch, loggedInUserId);
    yield put({
      type: types.SUBMIT_BRANCH_SUCCESS,
      submittedBranch: jsonData
    });

    if (mode === submitMode.CREATE) {
      yield put({ type: types.OPEN_CREATE_BRANCH_DIALOG, open: false });
    } else {
      yield put({ type: types.OPEN_EDIT_BRANCH_DIALOG, open: false });
      yield put({
        type: types.DEACTIVATE_OR_DELETE_BRANCH_DIALOG,
        open: false,
        branchId: 0,
        status: 0
      });
    }
  } catch (e) {
    yield resolveError(types.SUBMIT_BRANCH_FAILURE, e);
  } finally {
    yield put({ type: types.SUBMIT_BRANCH_FINISHED });
  }
}

function* watchDeleteOrDeactiveBranch({ branch }) {
  try {
    const loggedInUserId = yield getLoggedInUserId();
    yield put({ type: types.START_SUBMIT_BRANCH });
    const { jsonData } = yield call(branchesApi.updateBranch, branch, loggedInUserId);

    yield put({
      type: types.SUBMIT_BRANCH_SUCCESS,
      submittedBranch: jsonData
    });

    yield put({ type: types.GET_ALL_BRANCH });

    yield put({
      type: types.DEACTIVATE_OR_DELETE_BRANCH_DIALOG,
      open: false,
      branchId: 0,
      status: 0
    });
  } catch (e) {
    yield resolveError(types.SUBMIT_BRANCH_FAILURE, e);
  } finally {
    yield put({ type: types.SUBMIT_BRANCH_FINISHED });
  }
}

function* watchFetchBranchDetailsForLoggedinUser({ userId }) {
  try {
    yield put({ type: types.START_FETCH_BRANCH_DETAILS_FOR_LOGGEDIN_USER });

    const { jsonData } = yield call(branchesApi.getBranchForUser, userId);
    yield put({
      type: types.FETCH_BRANCH_DETAILS_FOR_LOGGEDIN_USER_SUCCESS,
      branch: jsonData
    });
  } catch (e) {
    yield resolveError(types.FETCH_BRANCH_DETAILS_FOR_LOGGEDIN_USER_FAILURE, e);
  } finally {
    yield put({ type: types.FETCH_BRANCH_DETAILS_FOR_LOGGEDIN_USER_FINISHED });
  }
}

function* watchFetchBranchDetailsByBranchId({ branchId }) {
  try {
    yield put({ type: types.START_FETCH_BRANCH_DETAILS_BY_BRANCH_ID });

    const { jsonData } = yield call(branchesApi.getBranchById, branchId);
    yield put({
      type: types.FETCH_BRANCH_DETAILS_BY_BRANCH_ID_SUCCESS,
      branch: jsonData
    });
  } catch (e) {
    yield resolveError(types.FETCH_BRANCH_DETAILS_BY_BRANCH_ID_FAILURE, e);
  } finally {
    yield put({ type: types.FETCH_BRANCH_DETAILS_BY_BRANCH_ID_FINISHED });
  }
}

//This is used to catch all the errors in case of request unsuccessful, and will extract the actual error message.
function* resolveError(type, error) {
  let errorMessageCaptured = false;
  let completeErrorMessage = {};
  if (!error.ok) {
    try {
      const clone = error.clone();
      yield clone.text().then((text) => {
        completeErrorMessage = JSON.parse(text);
        errorMessageCaptured = true;
      });
    } catch (err) {
      errorMessageCaptured = true;
      completeErrorMessage = err;
    }

    if (errorMessageCaptured) {
      const errorMessage = extractErrorMessage(completeErrorMessage);
      yield put({ type, errorMessage });
    }
  }
}

function extractErrorMessage(completeErrorMessage) {
  let errorMessage = '';

  try {
    const message = completeErrorMessage.exceptionMessage
      ? completeErrorMessage.exceptionMessage.split('Content:')[1]
      : completeErrorMessage.messageDetail;

    errorMessage = JSON.parse(message).errorMessage;
    if (!errorMessage) {
      errorMessage = 'An error occured';
    }
  } catch (error) {
    errorMessage = 'An error occured';
  }

  return errorMessage;
}
export default function* BranchesWatcher() {
  yield takeLatest(types.GET_ALL_BRANCH, watchLoadBranchesList);

  yield takeLatest(types.SUBMIT_BRANCH, watchCreateEditBranch);

  yield takeLatest(
    types.DEACTIVATE_OR_DELETE_BRANCH,
    watchDeleteOrDeactiveBranch
  );

  yield takeLatest(
    types.FETCH_BRANCH_DETAILS_FOR_LOGGEDIN_USER,
    watchFetchBranchDetailsForLoggedinUser
  );
  yield takeLatest(
    types.FETCH_BRANCH_DETAILS_BY_BRANCH_ID,
    watchFetchBranchDetailsByBranchId
  );
}
